import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import AboutPreview from "./components/AboutPreview";
import ProjectsPreview from "./components/ProjectsPreview";
import ContactPreview from "./components/ContactPreview";
import Footer from "./components/Footer";
import CustomCursor from "./components/CustomCursor";
import useScrollReveal from "./components/useScrollReveal";
import ThreeBackground from "./components/ThreeBackground";

function App() {
  useScrollReveal();
  return (
    <div className="app">
      <ThreeBackground />
      <CustomCursor />

      <Header />
      <main className="site-content">
        <div className="spotlight"></div>
        <Hero />
        <AboutPreview />
        <ProjectsPreview />
        <ContactPreview />
      </main>
      <Footer />
    </div>
  );
}

export default App;
